import { useSelector } from 'react-redux';
import { Input, Select, Form } from 'antd';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';
import useSolutionTaskConfiguration from '../hooks/useSolutionTaskConfiguration';

const SolutionTaskConfiguration = ({ form, solutionData, disabled }) => {
	const navigate = useNavigate();

	const { profileData } = useSelector((state) => state?.profile);

	const { taskObjectList, taskGroup, task, actionButtonOptions } = useSolutionTaskConfiguration();

	const taskCode = form.getFieldValue('taskCode');
	const processCode = form.getFieldValue('processCode');
	const processVersion = form.getFieldValue('processVersion');

	return (
		<>
			<Form.Item noStyle name="solutionTaskId" />

			<Box mb={2}>
				<Typography fontSize={14} fontWeight={500} mb={0.5}>
					Task Group
				</Typography>

				<Form.Item
					style={{ marginBottom: 0 }}
					name="taskGroupCode"
					rules={[
						{
							required: true,
							message: 'Task group is required',
						},
					]}
				>
					<Select
						style={{ width: '100%' }}
						placeholder="Select from the list"
						getPopupContainer={(trigger) => trigger.parentNode}
						onSelect={(value) =>
							form.setFieldsValue({
								taskCode: '',
								taskRole: '',
								taskActionTaken: '',
								taskGroupCode: value,
								templatenamePropertyCodes: [],
								type: value?.toLowerCase() === 'tgc-task_action' ? 'Script' : 'Form',
							})
						}
					>
						{taskGroup?.lynTaskGroup &&
							taskGroup?.lynTaskGroup?.map((value, index) => (
								<Select.Option key={index} value={value?.code}>
									{value?.name}
								</Select.Option>
							))}
					</Select>
				</Form.Item>
			</Box>

			<Form.Item noStyle shouldUpdate={(prev, current) => prev?.taskGroupCode !== current?.taskGroupCode}>
				{({ getFieldValue }) => {
					return (
						<Box mb={2}>
							<Typography fontSize={14} fontWeight={500} mb={0.5}>
								Task
							</Typography>

							<Form.Item
								style={{ marginBottom: 0 }}
								name="taskCode"
								rules={[
									{
										required: true,
										message: 'Task is required',
									},
								]}
							>
								<Select
									style={{ width: '100%' }}
									placeholder="Select from the list"
									getPopupContainer={(trigger) => trigger.parentNode}
									onSelect={(value) =>
										form.setFieldsValue({
											taskCode: value,
											label: taskObjectList?.[value]?.name,
											taskRole: taskObjectList?.[value]?.actionRole,
											taskActionTaken: taskObjectList?.[value]?.taskActionTaken,
										})
									}
								>
									{task?.lynTaskDetails
										?.filter((item) => item?.groupCode === getFieldValue('taskGroupCode'))
										?.map((value, index) => (
											<Select.Option key={index} value={value?.code}>
												{value?.name}
											</Select.Option>
										))}
								</Select>
							</Form.Item>
						</Box>
					);
				}}
			</Form.Item>

			<Form.Item noStyle name="type" />
			<Form.Item noStyle name="actionName" />
			<Form.Item noStyle name="companyCode" />
			<Form.Item noStyle name="taskActionTaken" />

			<Box mb={2}>
				<Typography fontSize={14} fontWeight={500} mb={0.5}>
					Role
				</Typography>

				<Form.Item
					style={{ marginBottom: 0 }}
					name="taskRole"
					rules={[
						{
							required: true,
							message: 'Role is required',
						},
					]}
				>
					<Input placeholder="To be auto generated" disabled />
				</Form.Item>
			</Box>

			<Box mb={2}>
				<Typography fontSize={14} fontWeight={500} mb={0.5}>
					Action Buttons
				</Typography>

				<Form.Item
					style={{ marginBottom: 0 }}
					name="templatenamePropertyCodes"
					rules={[
						{
							required: true,
							message: 'Action button is required',
						},
					]}
				>
					<Select
						mode="multiple"
						style={{ width: '100%' }}
						placeholder="Select from the list"
						getPopupContainer={(trigger) => trigger.parentNode}
					>
						{actionButtonOptions?.map((value, index) => (
							<Select.Option key={index} value={value?.altCode}>
								{value?.label}
							</Select.Option>
						))}
					</Select>
				</Form.Item>
			</Box>

			{disabled && (
				<Box mb={2} display="flex" justifyContent="space-between" alignItems="center">
					{/* <Link
						to="/form-builder"
						state={{
							...solutionData,
							taskCode,
							processCode,
							processVersion,
						}}
						style={{
							width: '100%',
							display: 'block',
							textDecoration: 'none',
						}}
					> */}
					<Button
						fullWidth
						sx={{ py: '2px' }}
						variant="outlined"
						onClick={() => {
							navigate('/form-builder', {
								state: {
									...solutionData?.solution,
									taskCode,
									processCode,
									processVersion,
									version: processVersion,
									companyCode: profileData?.creatorOrganizationId,
								},
							});
						}}
					>
						Create Form
					</Button>
					{/* </Link> */}
				</Box>
			)}
		</>
	);
};

export default SolutionTaskConfiguration;
